import './App.css';
import {BrowserRouter as Router, Switch, Route, Link} from 'react-router-dom';
import Landing from "./Pages/Landing";
import Voucher from "./Pages/Voucher";
import Print from "./Pages/Print";
import ReactGA from 'react-ga';
import {useEffect, useState} from "react";
import LandingSoldOutMessage from "./Pages/LandingSoldOutMessage";
import FunctionsData from "./Functions/FunctionsData";
import NotFound from "./Pages/NotFound";
import LandingCommunity from "./Pages/LandingCommunity";
import {useMsal} from "@azure/msal-react";
import LandingSoldOutMessageCommunity from "./Pages/LandingSoldOutMessageCommunity";
import LandingSoldOutMessageOutreach from "./Pages/LandingSoldOutMessageOutreach";
import MsGraphInfo from "./Pages/Info/MsGraphInfo";
import LandingCommunityLogs from "./Pages/LandingCommunity/Logs/LandingCommunityLogs";

function App(props) {

	const { instance,accounts } = useMsal();
	const userAccount = accounts[0];
	if(props.community || props.inspectors || props.outreach) MsGraphInfo(props.config);

	// console.log({instance}, {accounts});

	const [t,setT] = useState(false);
	const [available,setAvailable] = useState(0);
	const [availableLoading,setAvailableLoading] = useState(true);
	const [microchipOnly,setMicrochipOnly] = useState(false);

	useEffect(() => {
		fetch(FunctionsData.getApiUrl('/api/search/a1/startup'))
			.then (res => res.json())
			.then ((r) => {
			// console.log(r);
			sessionStorage.setItem("tkn", r.data);
			setT(true);
		});
	}, [])

	useEffect(() => {
		if(t === true) {
			FunctionsData.fetchDataGet(
				'/api/voucher/all_available',
				setAvailable,
				availableLoading,
				setAvailableLoading
			)
		}
	}, [t]);

	useEffect(() => {
		try {
			if(props.community || props.inspectors || props.outreach) localStorage.setItem("groups", accounts[0].idTokenClaims.groups)
		} catch (e) {
			// console.log(e);
		}
	}, [accounts]);


	if(t === false || availableLoading === true) return null;
	return (
		<Router>
			<div>
				<Switch>
					{
						(props.community || props.inspectors || props.outreach) ?
							<Route exact path='/'
							       render={(p) => (
								       <>
									      {available === 0
        ? (
          props.outreach
            ? <LandingSoldOutMessageOutreach {...p} {...props} ReactGA={ReactGA} />
            : <LandingSoldOutMessageCommunity {...p} {...props} ReactGA={ReactGA} />
        )
        : (
          <LandingCommunity
            {...p}
            {...props}
            accounts={accounts}
            instance={instance}
            userAccount={userAccount}
            ReactGA={ReactGA}
            setMicrochipOnly={setMicrochipOnly}
            microchipOnly={microchipOnly}
          />
        )
      }
								       </>
							       )}
							/>
							:
							<Route exact path='/'
							       render={(props) => (
								       <>
									       {
										       (available===0) ?
											       <LandingSoldOutMessage {...props} ReactGA={ReactGA}  />
											       :
											       <Landing {...props} ReactGA={ReactGA}  setMicrochipOnly={setMicrochipOnly} microchipOnly={microchipOnly}  />
									       }
								       </>
							       )}
							/>
					}
					<Route exact path='/voucher' component={Voucher}/>
					<Route exact path='/logs' component={LandingCommunityLogs}/>
					<Route exact path='/print' component={Print}/>
					<Route component={NotFound} />
				</Switch>
				<small style={{color:'lightGrey', fontSize:8, margin:20}}>{available}</small>
			</div>
		</Router>
	);
}

export default App;